export interface AddActivities {
  user_id: string;
  usr_role_track_id: string;
  token:string;
  customer_id: string; 
  comments: string;
  main_activity_id: string;
  sub_activity: string;
  activityNew: string;
  activity_id?: string;
}
export interface ActivityList{
  user_id: string;
  usr_role_track_id: string;
  token:string;
  customer_id: string; 
  created_by_name:string;
  activity_id:string
}
export interface DeleteActivity{
  user_id: string;
  usr_role_track_id: string;
  token:string;
  customer_id: string; 
  activity_id: string;
}